export default __webpack_public_path__ + "static/Денежный поток 10-4db54a9d4b146cc96d5514502f06ebb3.jpg";